
<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>
<div class="k-overlay" *ngIf="editWinOpen"></div>

<div class="container my-5">
  <div class="card" #appendTo>

    <div class="card-body no-border">

      <div class="card-title">
        <h3 class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'sliders']"></fa-icon>
          My Placement Reviews
        </h3>
      </div>

      <kendo-grid
        [kendoGridBinding]="gridData"
        [sort]="sort"
        [sortable]="true"
        [groupable]="true"
        [resizable]="true"
        [filter]="filter"
        filterable="menu"
        (filterChange)="filterChange($event)"
        (sortChange)="sortChange($event)"
        style="height: calc(100vh - 200px); min-height: 400px;"
        [pageSize]="pageSize"
        [pageable]="true">

        <!-- EDIT -->
        <kendo-grid-column title="Edit" [width]="60" [locked]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button [hidden]="!dataItem.can_edit" (click)="onEditClick(dataItem, windowTitleBar)" kendoButton class="icon-btn">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>
        <!-- <kendo-grid-column title="Can Edit" [width]="60" [locked]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.can_edit }}
          </ng-template>
        </kendo-grid-column> -->

        <!-- STUDENT -->
        <kendo-grid-column field="student" title="Student" [width]="250" [locked]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.student }}
          </ng-template>
        </kendo-grid-column>

        <!-- STUDENT INSTITUTION -->
        <kendo-grid-column field="student_institution_id" title="Student Institution ID" [width]="140">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.student_institution_id }}
          </ng-template>
        </kendo-grid-column>

        <!-- PLACEMENT LOCATION -->
        <kendo-grid-column field="placement_location" title="Placement Location" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.placement_location }}
          </ng-template>
        </kendo-grid-column>

        <!-- SUPERVISOR -->
        <kendo-grid-column field="supervisor" title="Supervisor" [width]="250">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.supervisor }}
          </ng-template>
        </kendo-grid-column>

        <!-- START DATE -->
        <kendo-grid-column field="placement_start_date" title="Placement Start Date" [width]="120" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.placement_start_date | date:'dd/MM/yyyy' }}
          </ng-template>
        </kendo-grid-column>

        <!-- END DATE -->
        <kendo-grid-column field="placement_end_date" title="Placement End Date" [width]="120" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.placement_end_date | date:'dd/MM/yyyy' }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="student_assessment_start_status" title="Student Self Assessment (Start Placement)" [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="status-cell">
              <ng-container *ngIf="dataItem.student_assessment_start_status == 'Start' || dataItem.student_assessment_start_status == 'In Progress'">
                <a (click)="openAssessment(dataItem, 'student_start_assessment_id')" class="status-link">
                  {{ dataItem.student_assessment_start_status }}
                </a>
              </ng-container>

              <ng-container *ngIf="dataItem.student_assessment_start_status != 'Start' && dataItem.student_assessment_start_status != 'In Progress'">
                <span class="status-text">
                  {{ dataItem.student_assessment_start_status }}
                </span>
                <span class="actions">
                  <button *ngIf="dataItem.student_assessment_start_status == 'Completed' && dataItem.isToPrint('student_assessment_start_status')"
                          (click)="printReport(dataItem, 'student_start_assessment_id')"
                          class="icon-btn">
                    <fa-icon icon="print"></fa-icon>
                  </button>
                  <button (click)="viewAssessment(dataItem, 'student_start_assessment_id')" class="icon-btn"
                          *ngIf="dataItem.student_assessment_start_status == 'Completed' && dataItem.student_assessment_start_can_view">
                    <fa-icon icon="eye"></fa-icon>
                    </button>
                </span>
              </ng-container>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="student_assessment_mid_status" title="Student Self Assessment (Mid Placement)" [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>

            <div class="status-cell">
              <ng-container *ngIf="dataItem.student_assessment_mid_status == 'Start' || dataItem.student_assessment_mid_status == 'In Progress'">
                <a (click)="openAssessment(dataItem, 'student_mid_assessment_id')" class="status-link">
                  {{ dataItem.student_assessment_mid_status }}
                </a>
              </ng-container>

              <ng-container *ngIf="dataItem.student_assessment_mid_status != 'Start' && dataItem.student_assessment_mid_status != 'In Progress'">
                <span class="status-text">
                  {{ dataItem.student_assessment_mid_status }}
                </span>
                <span class="actions">
                  <button *ngIf="dataItem.student_assessment_mid_status == 'Completed' && dataItem.isToPrint('student_assessment_mid_status')"
                          (click)="printReport(dataItem, 'student_mid_assessment_id')"
                          class="icon-btn">
                    <fa-icon icon="print"></fa-icon>
                  </button>
                  <button (click)="viewAssessment(dataItem, 'student_mid_assessment_id')" class="icon-btn"
                          *ngIf="dataItem.student_assessment_mid_status == 'Completed' && dataItem.student_assessment_mid_can_view">
                    <fa-icon icon="eye"></fa-icon>
                    </button>
                </span>
              </ng-container>

            </div>

          </ng-template>
        </kendo-grid-column>

        <!-- ================= MID SUPERVISOR ================= -->
        <kendo-grid-column field="supervisor_assessment_mid_status" title="Supervisor Assessment (Mid Placement) " [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="status-cell">
              <ng-container *ngIf="dataItem.supervisor_assessment_mid_status == 'Start' || dataItem.supervisor_assessment_mid_status == 'In Progress'">
                <a (click)="openAssessment(dataItem, 'supervisor_mid_assessment_id')" class="status-link">
                  {{ dataItem.supervisor_assessment_mid_status }}
                </a>
              </ng-container>
              <ng-container *ngIf="dataItem.supervisor_assessment_mid_status != 'Start' && dataItem.supervisor_assessment_mid_status != 'In Progress'">
                <span class="status-text">
                  {{ dataItem.supervisor_assessment_mid_status }}
                </span>
                <span class="actions">
                  <button *ngIf="dataItem.supervisor_assessment_mid_status == 'Completed' && dataItem.isToPrint('supervisor_assessment_mid_status')"
                          (click)="printReport(dataItem, 'supervisor_mid_assessment_id')"
                          class="icon-btn">
                    <fa-icon icon="print"></fa-icon>
                  </button>
                  <button (click)="viewAssessment(dataItem, 'supervisor_mid_assessment_id')" class="icon-btn"
                          *ngIf="dataItem.supervisor_assessment_mid_status == 'Completed' && dataItem.supervisor_assessment_mid_can_view">
                    <fa-icon icon="eye"></fa-icon>
                    </button>
                </span>
              </ng-container>
            </div>
            <ng-container *ngIf="dataItem.display_supervisor_mid_review_visible && dataItem.supervisor_assessment_mid_status == 'Completed'">
              <br>
              <span >Student Visible</span>
              <input type="checkbox" kendoCheckBox size="large" style="margin-left: 5px"
                     [checked]="dataItem.supervisor_mid_review_visible" (click)="setMidReviewVisible(dataItem)" />
            </ng-container>
          </ng-template>
        </kendo-grid-column>

        <!-- ================= END STUDENT ================= -->
        <kendo-grid-column field="student_assessment_end_status" title="Student Self Assessment (End Placement)" [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="status-cell">

              <ng-container *ngIf="dataItem.student_assessment_end_status == 'Start' || dataItem.student_assessment_end_status == 'In Progress'">
                <a (click)="openAssessment(dataItem, 'student_end_assessment_id')" class="status-link">
                  {{ dataItem.student_assessment_end_status }}
                </a>
              </ng-container>

              <ng-container *ngIf="dataItem.student_assessment_end_status != 'Start' && dataItem.student_assessment_end_status != 'In Progress'">
                <span class="status-text">
                  {{ dataItem.student_assessment_end_status }}
                </span>
                <span class="actions">
                  <button *ngIf="dataItem.student_assessment_end_status == 'Completed' && dataItem.isToPrint('student_assessment_end_status')"
                          (click)="printReport(dataItem, 'student_end_assessment_id')"
                          class="icon-btn">
                    <fa-icon icon="print"></fa-icon>
                  </button>
                  <button (click)="viewAssessment(dataItem, 'student_end_assessment_id')" class="icon-btn"
                          *ngIf="dataItem.student_assessment_end_status == 'Completed' && dataItem.student_assessment_end_can_view">
                    <fa-icon icon="eye"></fa-icon>
                    </button>
                </span>
              </ng-container>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="supervisor_assessment_end_status" title="Supervisor Assessment (End Placement) " [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="status-cell">
              <ng-container *ngIf="dataItem.supervisor_assessment_end_status == 'Start' || dataItem.supervisor_assessment_end_status == 'In Progress'">
                <a (click)="openAssessment(dataItem, 'supervisor_end_assessment_id')" class="status-link">
                  {{ dataItem.supervisor_assessment_end_status }}
                </a>
              </ng-container>
              <ng-container *ngIf="dataItem.supervisor_assessment_end_status != 'Start' && dataItem.supervisor_assessment_end_status != 'In Progress'">
                <span class="status-text">
                  {{ dataItem.supervisor_assessment_end_status }}
                </span>
                <span class="actions">
                  <button *ngIf="dataItem.supervisor_assessment_end_status == 'Completed' && dataItem.isToPrint('supervisor_assessment_end_status')"
                          (click)="printReport(dataItem, 'supervisor_end_assessment_id')"
                          class="icon-btn">
                    <fa-icon icon="print"></fa-icon>
                  </button>
                   <button (click)="viewAssessment(dataItem, 'supervisor_end_assessment_id')" class="icon-btn"
                           *ngIf="dataItem.supervisor_assessment_end_status == 'Completed' && dataItem.supervisor_assessment_end_can_view">
                    <fa-icon icon="eye"></fa-icon>
                    </button>
                </span>
              </ng-container>


            </div>
            <ng-container *ngIf="dataItem.display_supervisor_end_review_visible && dataItem.supervisor_assessment_end_status == 'Completed'">
              <br>
              <span >Student Visible</span>
              <input type="checkbox" kendoCheckBox size="large" style="margin-left: 5px"
                     [checked]="dataItem.supervisor_end_review_visible" (click)="setEndReviewVisible(dataItem)" />
            </ng-container>

          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

    </div>
  </div>
</div>

<div kendoDialogContainer></div>
<div kendoWindowContainer></div>
